<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import DatePicker from 'vue2-datepicker'
import datePickerLang from '@/helpers/date-picker-lang'
import SettingOptions from '@/components/SettingOptions'
import McButton from '@/components/McButton'
import { gmapApi } from 'vue2-google-maps'
import moment from 'moment'
moment.locale('id')

import { GET_RAW_LOCATION } from '@/services/api/fleet'
import { SUMMARY_TRIP_DRIVER, LAST_SUMMARY_TRIP_DRIVER } from '@/services/api/master/employees'
import { Helper } from '@/mixin/helper'
import { GET_DETAIL_EMPLOYEE } from '@/services/api/master/employees'
import { mapGetters } from 'vuex'

/**
 * Starter component
 */
export default {
  name: 'ModalRiwayatDriver',
  page: {
    title: 'Riwayat Perjalanan',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    DatePicker,
    SettingOptions,
    McButton,
    'gmap-custom-marker': GmapCustomMarker,
  },
  mixins: [Helper],
  apollo: {
    employee: {
      query: GET_DETAIL_EMPLOYEE,
      variables() {
        return {
          filter: {
            userId: parseInt(this.$route.params.id),
          },
        }
      },
    },
    summaryTripDriver: {
      query: SUMMARY_TRIP_DRIVER,
      variables() {
        return {
          filter: {
            driverId: parseInt(this.$route.params.id),
            startDate: this.now(),
            endDate: this.now(),
          },
        }
      },
      result({ data, loading }) {
        if (!loading) {
          setTimeout(() => {
            this.calcRoute(data.summaryTripDriver.summaryTripDriver)
          }, 300)
        }
      },
    },
  },
  data() {
    return {
      map: null,
      gMapOptions: {},
      zoom: 5.56,
      center: {
        lat: -2.958881,
        lng: 109.5543666,
      },
      makeShortcuts: [
        {
          text: this.$t('global.time.today'),
          value: () => this.getShortcutPeriod(0, 0),
          onClick: () => this.applyShortcutPeriod(this.getShortcutPeriod(0, 0)),
        },
        {
          text: this.$t('global.time.yesterday'),
          value: () => this.getShortcutPeriod(1, 1),
          onClick: () => this.applyShortcutPeriod(this.getShortcutPeriod(1, 1)),
        },
        {
          text: this.$t('global.time.last3Days'),
          value: () => this.getShortcutPeriod(2, 0),
          onClick: () => this.applyShortcutPeriod(this.getShortcutPeriod(2, 0)),
        },
      ],

      employee: {
        employee: {},
      },

      summaryTripDriver: {
        summaryTripDriver: {
          summaryTrip: [],
        },
      },

      lastSummaryTripDriver: [],
      periode: [],
      periodeTemp: [],
      allPath: [],
      showHideDetail: false,
      allHistory: true,
      popoverShow: false,
      modalDriverHistory: true,
      pastDate: null,
      futureEnd: null,
      move: {
        numDeltas: 100,
        delay: 10, //milliseconds
        i: 0,
        deltaLat: null,
        deltaLng: null,
      },

      isMonth: true,

      trafficLayer: null,
      directionsService: null,
      directionsRenderer: null,
      bounds: null,
      position: {
        start: {},
        end: {
          lat: null,
          lng: null,
        },
      },
      stopPosition: true,
      stopPositions: [],
      infoWindow: {
        status: false,
        type: 'totalHourStop',
        position: { lat: null, lng: null },
        totalHourStop: '',
        speed: 0,
        sentOn: '',
      },
      visible: true,

      myTime: 0,
      str: 0,
      stp: 0,
    }
  },
  computed: {
    google: gmapApi,
    datePickerLang() {
      return datePickerLang()
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
  },
  async mounted() {
    const self = this
    this.periode = [
      moment(new Date()).format('YYYY-MM-DD 00:00'),
      moment(new Date()).format('YYYY-MM-DD 23:59'),
    ]

    const currentDate = moment(new Date())
    const pastMonth = this.hasAccess(['y3a-last-6-month:read'])
      ? moment(currentDate).subtract(8, 'months')
      : moment(currentDate).subtract(3, 'months')
    const pastDate = moment(pastMonth).endOf('month')

    this.pastDate = new Date(pastDate)
    this.futureEnd = new Date(currentDate)

    await this.$refs.MapHistoryDriver.$mapPromise.then((map) => {
      self.map = map
      const directionsService = new this.google.maps.DirectionsService()
      const directionsRenderer = new this.google.maps.DirectionsRenderer({
        suppressMarkers: false,
      })
      const trafficLayer = new this.google.maps.TrafficLayer()
      self.gMapOptions = {
        minZoom: 3,
        mapTypeControl: false,
        zoomControl: true,
        zoomControlOptions: {
          position: self.google.maps.ControlPosition.LEFT_BOTTOM,
        },
        scaleControl: true,
        streetViewControl: true,
        streetViewControlOptions: {
          position: self.google.maps.ControlPosition.LEFT_BOTTOM,
        },
        fullscreenControl: false,
      }
      this.trafficLayer = trafficLayer
      this.directionsService = directionsService
      this.directionsRenderer = directionsRenderer
    })
  },
  methods: {
    getShortcutPeriod(startDaysAgo, endDaysAgo) {
      return [
        moment().subtract(startDaysAgo, 'days').format('YYYY-MM-DD 00:00'),
        moment().subtract(endDaysAgo, 'days').format('YYYY-MM-DD 23:59'),
      ]
    },
    applyShortcutPeriod(period) {
      this.periode = period
      setTimeout(() => this.loadData(), 100)
    },
    isShortcutActive(shortcut) {
      if (!Array.isArray(this.periode) || this.periode.length !== 2) return false

      const value = shortcut.value()
      return value.every((date, index) => moment(date).isSame(moment(this.periode[index]), 'minute'))
    },
    disabledRange: function (date) {
      return new Date(date) <= new Date(this.pastDate) || new Date(date) >= new Date(this.futureEnd)
    },

    pickDate(date) {
      let past_date = moment(new Date(this.pastDate)).add(1, 'days')
      let past_date_two = moment(new Date(this.pastDate)).add(2, 'days')
      if (this.momentYmD(past_date) == this.momentYmD(date)) {
        this.pastDate = new Date(date.getTime() - 24 * 1 * 3600 * 1000)
      } else if (this.momentYmD(past_date_two) == this.momentYmD(date)) {
        this.pastDate = new Date(date.getTime() - 24 * 2 * 3600 * 1000)
      } else {
        this.pastDate = new Date(date.getTime() - 24 * 3 * 3600 * 1000)
      }

      let new_date = moment(new Date(date)).add(1, 'days')
      if (this.momentYmD(date) == this.momentYmD(new Date())) {
        this.futureEnd = new Date(date.getTime() + 24 * 1 * 3600 * 1000)
      } else if (this.momentYmD(new Date(new_date)) == this.momentYmD(new Date())) {
        this.futureEnd = new Date(date.getTime() + 24 * 2 * 3600 * 1000)
      } else if (this.momentYmD(date) == this.momentYmD(this.pastDate)) {
        this.pastDate = date
      } else {
        this.futureEnd = new Date(date.getTime() + 24 * 3 * 3600 * 1000)
      }
    },

    closePicker() {
      const currentDate = moment(new Date())
      const pastMonth = this.hasAccess(['y3a-last-6-month:read'])
        ? moment(currentDate).subtract(8, 'months')
        : moment(currentDate).subtract(3, 'months')
      const pastDate = moment(pastMonth).endOf('month')

      this.pastDate = new Date(pastDate)
      this.futureEnd = new Date(currentDate)
      this.periode = [...this.periodeTemp]
    },

    closeCalendar() {
      this.periode = [...this.periodeTemp]
      if (this.$refs.periodePicker) {
        this.$refs.periodePicker.defaultOpen = false
      }
    },

    async loadData() {
      this.periodeTemp = [...this.periode]
      this.closeCalendar()
      await this.$apollo.queries.summaryTripDriver.refetch({
        filter: {
          startDate: this.momentToISOString(`${this.periode[0]}`),
          endDate: this.momentToISOString(`${this.periode[1]}`),
          driverId: parseInt(this.$route.params.id),
        },
      })

      this.calcRoute(this.summaryTripDriver.summaryTripDriver.summaryTrips)
      this.closePicker()
    },

    OpenInfo(lat, lng, totalHourStop) {
      this.CloseInfo()
      setTimeout(() => {
        this.infoWindow.status = true
        this.infoWindow.type = 'totalHourStop'
        ;(this.infoWindow.position = {
          lat: lat,
          lng: lng,
        }),
          (this.infoWindow.totalHourStop = totalHourStop)
      }, 100)
    },

    CloseInfo() {
      this.infoWindow.status = false
    },

    showLineDetail(event, fleetPlanCoordinates) {
      this.infoWindow.status = false
      setTimeout(() => {
        this.infoWindow.status = true
        this.infoWindow.type = 'speed'
        this.infoWindow.position = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        }
        this.infoWindow.speed = fleetPlanCoordinates.speed
        this.infoWindow.sentOn = fleetPlanCoordinates.sentOn
      }, 100)
    },

    calcRoute(data) {
      this.resetPolyline()
      setTimeout(() => {
        if (data.summaryTrips.length == 0) {
          this.setMarker('start', { lat: null, lng: null }, 0)
          this.setMarker('end', { lat: null, lng: null }, 0)
          return
        }
        var self = this
        var bounds = new this.google.maps.LatLngBounds()

        bounds.extend(
          new self.google.maps.LatLng(data.summaryTrips[0].startLat, data.summaryTrips[0].startLong)
        )

        bounds.extend(
          new self.google.maps.LatLng(
            data.summaryTrips[data.summaryTrips.length - 1].stopLat,
            data.summaryTrips[data.summaryTrips.length - 1].stopLong
          )
        )

        const lastIndex = data.summaryTrips.length - 1
        data.summaryTrips.forEach(async (element, index) => {
          bounds.extend(new self.google.maps.LatLng(element.startLat, element.startLong))

          bounds.extend(new self.google.maps.LatLng(element.stopLat, element.stopLong))
          let filter = {
            filter: {
              vehicleId: element.vehicleId,
              startDate: element.startTime,
              endDate: element.stopTime,
            },
          }

          this.getLine(filter, lastIndex, index, element.totalHourStop, false)
        })
        this.map.fitBounds(bounds)
      }, 100)
    },

    createAllPolyline() {
      this.resetPolyline()
      this.stopPosition = true
      this.infoWindow.status = false
      var allFleetPlanCoordinates = []
      setTimeout(() => {
        this.summaryTripDriver.summaryTripDriver.summaryTrips
          .slice()
          .reverse()
          .forEach((element) => {
            const fleetPlanCoordinates = element.details
            allFleetPlanCoordinates = [...allFleetPlanCoordinates, ...element.details]
            for (var i = 0; i < fleetPlanCoordinates.length - 1; i++) {
              var polylinePlanCoordinates = []

              polylinePlanCoordinates.push(
                new this.google.maps.LatLng(
                  fleetPlanCoordinates[i]['latitude'],
                  fleetPlanCoordinates[i]['longitude']
                )
              )
              polylinePlanCoordinates.push(
                new this.google.maps.LatLng(
                  fleetPlanCoordinates[i + 1]['latitude'],
                  fleetPlanCoordinates[i + 1]['longitude']
                )
              )
              this.crateLine(fleetPlanCoordinates[i], polylinePlanCoordinates)
            }
          })
        this.moving(allFleetPlanCoordinates)
      }, 200)
    },

    createPolyline(index, totalHourStop) {
      this.resetPolyline()
      this.stopPosition = false
      this.infoWindow.status = false
      const fleetPlanCoordinates =
        this.summaryTripDriver.summaryTripDriver.summaryTrips[index].details

      setTimeout(() => {
        for (var i = 0; i < fleetPlanCoordinates.length - 1; i++) {
          if (i == 0) {
            this.setMarker(
              'start',
              {
                lat: fleetPlanCoordinates[i].latitude,
                lng: fleetPlanCoordinates[i].longitude,
              },
              0,
              totalHourStop
            )
          }
          var polylinePlanCoordinates = []

          polylinePlanCoordinates.push(
            new this.google.maps.LatLng(
              fleetPlanCoordinates[i].latitude,
              fleetPlanCoordinates[i].longitude
            )
          )
          polylinePlanCoordinates.push(
            new this.google.maps.LatLng(
              fleetPlanCoordinates[i + 1].latitude,
              fleetPlanCoordinates[i + 1].longitude
            )
          )

          this.crateLine(fleetPlanCoordinates[i], polylinePlanCoordinates)
        }

        this.moving(fleetPlanCoordinates)
      }, 200)
    },

    getLine(filter, lastIndex, index, totalHourStop, play) {
      var self = this
      self.stopPositions.splice(0, self.stopPositions.length)

      this.$apollo
        .query({
          query: GET_RAW_LOCATION,
          variables: filter,
        })
        .then((response) => {
          if (response.data.rawLocations.isSuccessful) {
            const fleetPlanCoordinates = response.data.rawLocations.rawLocations
            var bounds = new this.google.maps.LatLngBounds()

            if (index == 0) {
              this.setMarker(
                'end',
                {
                  lat: fleetPlanCoordinates[fleetPlanCoordinates.length - 1].latitude,
                  lng: fleetPlanCoordinates[fleetPlanCoordinates.length - 1].longitude,
                },
                parseInt(fleetPlanCoordinates[fleetPlanCoordinates.length - 1].direction)
              )
            }

            for (var i = 0; i < fleetPlanCoordinates.length - 1; i++) {
              var polylinePlanCoordinates = []

              polylinePlanCoordinates.push(
                new this.google.maps.LatLng(
                  fleetPlanCoordinates[i].latitude,
                  fleetPlanCoordinates[i].longitude
                )
              )
              polylinePlanCoordinates.push(
                new this.google.maps.LatLng(
                  fleetPlanCoordinates[i + 1].latitude,
                  fleetPlanCoordinates[i + 1].longitude
                )
              )

              self.crateLine(fleetPlanCoordinates[i], polylinePlanCoordinates)

              if (i == 0) {
                self.stopPositions.push({
                  lat: fleetPlanCoordinates[i].latitude,
                  lng: fleetPlanCoordinates[i].longitude,
                  totalHourStop: totalHourStop,
                })
              }

              if (lastIndex == 0 && index == 0) {
                bounds.extend(
                  new self.google.maps.LatLng(
                    fleetPlanCoordinates[i].latitude,
                    fleetPlanCoordinates[i].longitude
                  )
                )
              }
            }

            if (lastIndex == index && lastIndex != 0) {
              this.setMarker(
                'start',
                {
                  lat: fleetPlanCoordinates[0].latitude,
                  lng: fleetPlanCoordinates[0].longitude,
                },
                0,
                totalHourStop
              )
            } else if (lastIndex == 0 && index == 0) {
              this.setMarker(
                'start',
                {
                  lat: fleetPlanCoordinates[0].latitude,
                  lng: fleetPlanCoordinates[0].longitude,
                },
                0,
                totalHourStop
              )
              this.setMarker(
                'end',
                {
                  lat: fleetPlanCoordinates[i].latitude,
                  lng: fleetPlanCoordinates[i].longitude,
                },
                parseInt(fleetPlanCoordinates[i].direction)
              )
              this.map.fitBounds(bounds)

              if (play) {
                // setTimeout(() => {
                self.stop(self.str, self.stp)
                var interval = 500
                fleetPlanCoordinates.forEach(function (row, i) {
                  this.myTime = setTimeout(function () {
                    self.transition(
                      [row.latitude, row.longitude],
                      [fleetPlanCoordinates[i + 1].latitude, fleetPlanCoordinates[i + 1].longitude],
                      fleetPlanCoordinates[i + 1].direction
                    )
                  }, i * interval)

                  if (i == 0) {
                    this.str = this.myTime
                  } else if (i == fleetPlanCoordinates.length - 1) {
                    this.stp = this.myTime
                  }
                })
                // }, 1000);
              }
            }

            this.summaryTripDriver.summaryTripDriver.summaryTrips[index] = {
              ...this.summaryTripDriver.summaryTripDriver.summaryTrips[index],
              details: fleetPlanCoordinates,
            }
          }
        })
        // eslint-disable-next-line no-console
        .catch((e) => console.log(e))
    },

    async createPolylineMoving(totalHourStop, play) {
      this.resetPolyline()
      const filter = {
        filter: {
          startDate: this.lastSummaryTripDriver.summaryTrips.startTime,
          endDate: this.lastSummaryTripDriver.summaryTrips.stopTime,
          vehicleId: this.lastSummaryTripDriver.summaryTrips.vehicleId,
        },
      }

      this.getLine(filter, 0, 0, totalHourStop, play)
    },

    async crateLine(fleetPlanCoordinates, polylinePlanCoordinates) {
      // create a polyline
      var self = this
      var path = new this.google.maps.Polyline({
        path: polylinePlanCoordinates,
        geodesic: true,
        strokeOpacity: 1.0,
        strokeWeight: 5,
      })

      path.addListener('click', function (e) {
        self.showLineDetail(e, fleetPlanCoordinates)
      })

      this.allPath.push(path)

      // set the color of the segment based on the lowest index point
      if (fleetPlanCoordinates.speed >= 0 && fleetPlanCoordinates.speed <= 20) {
        path.setOptions({
          strokeColor: '#f41d00',
        })
      } else if (fleetPlanCoordinates.speed > 20 && fleetPlanCoordinates.speed <= 40) {
        path.setOptions({
          strokeColor: '#f64a33',
        })
      } else if (fleetPlanCoordinates.speed > 40 && fleetPlanCoordinates.speed <= 60) {
        path.setOptions({
          strokeColor: '#ffa133',
        })
      } else if (fleetPlanCoordinates.speed > 60 && fleetPlanCoordinates.speed <= 80) {
        path.setOptions({
          strokeColor: '#71b099',
        })
      } else if (fleetPlanCoordinates.speed > 80) {
        path.setOptions({
          strokeColor: '#137c55',
        })
      }

      path.setMap(this.map)
    },

    resetPolyline() {
      this.allPath.forEach((element) => {
        element.setMap(null)
      })

      this.allPath.splice(0, this.allPath.length)
    },

    setMarker(type, coordinate, direction, totalHourStop) {
      this.position[type] = {
        lat: coordinate.lat,
        lng: coordinate.lng,
        direction: parseInt(direction),
        totalHourStop: totalHourStop,
      }
    },

    moving(fleetPlanCoordinates) {
      const self = this
      let interval = 100

      this.stop(this.str, this.stp)
      // setTimeout(() => {
      for (let i = 0; i < fleetPlanCoordinates.length; i++) {
        this.myTime = setTimeout(function () {
          self.transition(
            [fleetPlanCoordinates[i].latitude, fleetPlanCoordinates[i].longitude],
            [fleetPlanCoordinates[i + 1].latitude, fleetPlanCoordinates[i + 1].longitude],
            fleetPlanCoordinates[i + 1].direction
          )
        }, i * interval)

        if (i == 0) {
          this.str = this.myTime
        } else if (i == fleetPlanCoordinates.length - 1) {
          this.stp = this.myTime
        }
      }
      // }, 1000);
    },

    stop(str1, stp1) {
      for (let i = str1; i < stp1; i++) {
        clearTimeout(i)
      }
    },

    transition(start, stop, direction) {
      this.move.i = 0
      this.move.deltaLat = (stop[0] - start[0]) / this.move.numDeltas
      this.move.deltaLng = (stop[1] - start[1]) / this.move.numDeltas
      this.moveMarker(stop, direction)
    },

    moveMarker(stop, direction) {
      stop[0] += this.move.deltaLat
      stop[1] += this.move.deltaLng

      this.setMarker(
        'end',
        {
          lat: stop[0],
          lng: stop[1],
        },
        parseInt(direction)
      )
      if (this.move.i != this.move.numDeltas) {
        this.move.i++
        setTimeout(this.move.moveMarker, this.move.delay)
      }
    },

    onClose() {
      this.popoverShow = false
    },

    toggleSideBar() {
      this.modalDriverHistory = !this.modalDriverHistory
    },

    getMoving() {
      // if (this.summaryTripDriver.summaryTripDriver.motionStatus !== "M") {
      // 	return;
      // }

      // var self = this;
      this.$apollo
        .query({
          query: LAST_SUMMARY_TRIP_DRIVER,
          variables: {
            filter: {
              driverId: parseInt(this.$route.params.id),
            },
          },
        })
        .then((response) => {
          if (response.data.lastSummaryTripDriver.isSuccessful) {
            this.lastSummaryTripDriver = response.data.lastSummaryTripDriver.lastSummaryTripDriver
            this.allHistory = !this.allHistory
          }
        })
        // eslint-disable-next-line no-console
        .catch((e) => console.log(e))
    },
  },
}
</script>

<template>
  <Layout>
    <div
      :class="{
        'card mc-liveview clearfix': modalDriverHistory === true,
        'card mc-liveview clearfix close-sidebar': modalDriverHistory === false,
      }"
    >
      <div class="mc-liveview__map close-history">
        <div class="mc-liveview-ico">
          <SettingOptions />
          <span class="mc-liveview-legend">
            <i id="legend" class="mc-fa icon-outline_info"></i>

            <b-popover
              ref="popover"
              target="legend"
              triggers="click"
              placement="rightmiddle"
              container="my-container"
              :variant="$store.state.config.theme_appearance"
              :show.sync="popoverShow"
            >
              <template #title>
                {{ $t('global.object.remarks') }}
                <span class="mc-popover-close" aria-hidden="true" @click="onClose">&times;</span>
              </template>

              <div
                class="mc-popover-content mc-popover-content--legend mc-popover-content--legend-speed"
              >
                <ul>
                  <li>
                    <p>{{ $t('global.object.fleetStatus') }}</p>
                    <div>
                      <label>
                        <img src="@/assets/images/vehicles/car/car-green.png" alt />
                        <span>{{ $t('global.filter.running') }}</span>
                      </label>
                      <label>
                        <img src="@/assets/images/vehicles/car/car-orange.png" alt />
                        <span>{{ $t('global.filter.idle') }}</span>
                      </label>
                      <label>
                        <img src="@/assets/images/vehicles/car/car-red.png" alt />
                        <span>{{ $t('global.filter.parking') }}</span>
                      </label>
                      <label>
                        <img src="@/assets/images/vehicles/car/car-grey.png" alt />
                        <span>{{ $t('global.filter.offline') }}</span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <p>{{ $t('liveView.infoWindow.fleetColor') }}</p>
                    <div>
                      <label>
                        <img src="@/assets/images/speedicon/80.svg" alt />
                        <span> > {{ `80 Km / ${$t('global.time.hours')}` }}</span>
                      </label>
                      <label>
                        <img src="@/assets/images/speedicon/61-80.svg" alt />
                        <span> {{ `61 - 80 Km / ${$t('global.time.hours')}` }}</span>
                      </label>
                      <label>
                        <img src="@/assets/images/speedicon/41-60.svg" alt />
                        <span>{{ `41 - 60 Km / ${$t('global.time.hours')}` }}</span>
                      </label>
                      <label>
                        <img src="@/assets/images/speedicon/21-40.svg" alt />
                        <span>{{ `21 - 40 Km / ${$t('global.time.hours')}` }}</span>
                      </label>
                      <label>
                        <img src="@/assets/images/speedicon/20.svg" alt />
                        <span>{{ `< 21 Km / ${$t('global.time.hours')}` }}</span>
                      </label>
                      <label>
                        <img src="@/assets/images/speedicon/help.svg" alt />
                        <span> {{ $t('liveView.filter.assisted') }}</span>
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </b-popover>
          </span>
        </div>
        <div class="mc-map-wrapper mc-map-wrapper--employee">
          <GmapMap
            id="map"
            ref="MapHistoryDriver"
            :center="center"
            :zoom="zoom"
            :options="gMapOptions"
            class="mc-map"
          >
            <gmap-custom-marker
              v-for="(row, index) in stopPositions"
              :key="index"
              :marker="{
                lat: parseFloat(row.lat),
                lng: parseFloat(row.lng),
              }"
              :offsetY="40"
            >
              <div v-if="stopPosition" class="text-center">
                <img
                  src="@/assets/images/caricon/stop-icon.svg"
                  alt="stop-icon"
                  @click="OpenInfo(parseFloat(row.lat), parseFloat(row.lng), row.totalHourStop)"
                />
              </div>
            </gmap-custom-marker>

            <GmapInfoWindow
              :position="infoWindow.position"
              :opened="infoWindow.status"
              @closeclick="CloseInfo"
            >
              <div
                v-if="infoWindow.type === 'totalHourStop'"
                class="mc-modal-fleet mc-modal-fleet--history mc-modal-fleet--history-stop"
              >
                <div class="mc-modal-fleet__item-status clearfix">
                  <p>
                    <i class="mc-fa icon-outline_timer"></i> {{ $t('global.filed.stopDuration') }}
                  </p>
                  <span>{{ infoWindow.totalHourStop }}</span>
                </div>
              </div>
              <div
                v-else-if="infoWindow.type === 'speed'"
                class="mc-modal-fleet mc-modal-fleet--history mc-modal-fleet--history-speed"
              >
                <div class="mc-modal-fleet__item-status clearfix">
                  <p>
                    <i class="mc-fa icon-outline_eye"></i>
                    {{ momentDMY_HI(infoWindow.sentOn) }}
                  </p>
                  <p><i class="mc-fa icon-outline_odometer"></i> {{ $t('global.object.speed') }}</p>
                  <span>{{ infoWindow.speed }} {{ `Km/${$t('global.time.hours')}` }}</span>
                  <p><i class="mc-fa"></i></p>
                </div>
              </div>
            </GmapInfoWindow>

            <span v-if="!stopPosition">
              <gmap-custom-marker
                v-for="(row, index) in stopPositions"
                :key="index"
                :marker="{
                  lat: parseFloat(position.start.lat),
                  lng: parseFloat(position.start.lng),
                }"
                :offsetY="40"
              >
                <div class="text-center">
                  <img
                    src="@/assets/images/caricon/stop-icon.svg"
                    alt="stopp-icon"
                    @click="
                      OpenInfo(
                        parseFloat(position.start.lat),
                        parseFloat(position.start.lng),
                        position.start.totalHourStop
                      )
                    "
                  />
                </div>
              </gmap-custom-marker>
            </span>

            <gmap-custom-marker
              v-if="position.end.lat && position.end.lng"
              :marker="{
                lat: parseFloat(position.end.lat),
                lng: parseFloat(position.end.lng),
              }"
              :offsetY="25"
            >
              <div class="text-center">
                <div
                  v-if="$store.state.fleets.markerPlate === true"
                  :class="`${
                    $store.state.fleets.markerLabelLayout === true
                      ? 'bg-white bottom-icon-shape'
                      : 'bg-transparant'
                  }`"
                  class="rounded"
                >
                  <h6 class="p-1">
                    <strong>{{ employee.employee.fullname }}</strong>
                  </h6>
                </div>
                <img
                  src="@/assets/images/caricon/car-dark.svg"
                  :style="`transform: rotate(${parseInt(position.end.direction)}deg);`"
                  alt="mceasy-lifeview-car-icon"
                />
              </div>
            </gmap-custom-marker>
          </GmapMap>

          <span class="mc-sidebar-toggle" @click="toggleSideBar">
            <i class="mc-fa fas fa-angle-left"></i>
          </span>

          <b-modal
            id="modal-history"
            v-model="modalDriverHistory"
            scrollable
            hide-footer
            hide-header
            size="md"
            class="mc-history-modal"
            no-close-on-backdrop
            hide-backdrop
          >
            <section v-if="allHistory">
              <!-- header -->
              <div slot="modal-header">
                <div class="card-title">
                  <span>
                    {{ $t('global.object.tripHistory') }}
                  </span>
                  <h4 class="font-size-14 mt-1">
                    {{ employee.employee.fullname }}
                  </h4>
                  <a class="mc-history-fleet__back" @click="$router.go(-1)">
                    <i class="mc-fa icon-outline_close"></i>
                  </a>
                </div>
              </div>
              <!-- body -->
              <div class="modal-body">
                <div v-if="$store.state.fleets.loadingHistory" class="text-center">
                  <div class="mc-loading">
                    <p></p>
                    <p></p>
                    <p></p>
                  </div>
                </div>
                <div v-else>
                  <b-row class="mc-history-modal__list">
                    <b-col md="12" class="pe-0 mb-3">
                      <label>{{ $t('global.object.period') }}</label>
                      <span id="tooltipHistory" class="mc-input-info__btn">
                        <i class="bx bx-info-circle"></i>
                      </span>
                      <b-tooltip target="tooltipHistory" triggers="click" placement="lefttop">
                        <ul>
                          <li>{{ $t('liveView.text.periodStart') }}.</li>
                          <li>
                            {{ $t('liveView.text.periodInfoText') }}
                          </li>
                        </ul>
                      </b-tooltip>
                      <date-picker
                        ref="periodePicker"
                        v-model="periode"
                        type="datetime"
                        :placeholder="$t('global.action.selectDate')"
                        class="mc-history-modal__list-date"
                        :confirm="false"
                        format="DD MMM YYYY HH:mm"
                        value-type="YYYY-MM-DD HH:mm"
                        :shortcuts="[]"
                        range-separator=" - "
                        range
                        :disabled-date="disabledRange"
                        :lang="datePickerLang"
                        @pick="pickDate"
                        @close="closePicker"
                      >
                        <template #sidebar>
                          <button
                            v-for="(shortcut, index) in makeShortcuts"
                            :key="index"
                            type="button"
                            class="mx-btn mx-btn-text mx-btn-shortcut"
                            :class="{ active: isShortcutActive(shortcut) }"
                            @click="shortcut.onClick"
                          >
                            {{ shortcut.text }}
                          </button>
                        </template>
                        <template #footer>
                          <span class="mr-3">
                            {{ momentDMYH(periode[0]) }} - {{ momentDMYH(periode[1]) }}
                          </span>
                          <b-button class="mx-2" variant="outline-primary" @click="closeCalendar()">
                            {{ $t('global.action.cancel') }}
                          </b-button>
                          <b-button variant="primary" @click="loadData">
                            {{ $t('global.action.apply') }}
                          </b-button>
                        </template>
                      </date-picker>
                    </b-col>
                    <b-col md="8">
                      <div class="form-check-right form-switch">
                        <input
                          id="moreinfo-history"
                          class="form-check-input ms-2"
                          type="checkbox"
                          @click="showHideDetail = !showHideDetail"
                        />
                        <span class="" for="moreinfo-history">
                          {{ $t('global.object.otherInfo') }}
                        </span>
                      </div>
                    </b-col>
                    <b-col mc="4" class="text-end">
                      <a class="text-primary" @click="createAllPolyline">
                        <i class="icon-outline_play-circle" /> {{ $t('global.filter.all') }}
                      </a>
                    </b-col>
                    <b-col md="12" class="mt-3">
                      <div class="mc-history-fleet">
                        <b-list-group class="mc-history-fleet__list">
                          <b-list-group class="mc-history-fleet__list">
                            <b-list-group-item
                              v-for="(row, index) in summaryTripDriver.summaryTripDriver
                                .summaryTrips"
                              :key="index"
                            >
                              <div class="d-flex justify-content-between">
                                <div>
                                  <span> {{ $t('global.object.startTime') }}</span>
                                  <p>{{ momentDMY_HI(row.startTime) }}</p>
                                </div>
                                <div>
                                  <span> {{ $t('global.object.stopTime') }}</span>
                                  <p>{{ momentDMY_HI(row.stopTime) }}</p>
                                </div>
                                <div>
                                  <a
                                    class="text-primary"
                                    @click="createPolyline(index, row.totalHourStop)"
                                  >
                                    <i class="icon-outline_play-circle" />
                                  </a>
                                </div>
                              </div>
                              <dl v-if="showHideDetail" class="clearfix">
                                <dt>{{ $t('global.object.tripTime') }}</dt>
                                <dd>{{ row.totalHourStart }}</dd>
                                <dt>{{ `${$t('global.object.mileage')} (Km)` }}</dt>
                                <dd>{{ row.tripMileage }}</dd>
                                <dt>{{ $t('global.field.stopDuration') }}</dt>
                                <dd>{{ row.totalHourStop }}</dd>
                                <dt>{{ $t('global.fleet') }}</dt>
                                <dd>{{ row.vehicle.licensePlate }}</dd>
                              </dl>
                            </b-list-group-item>
                          </b-list-group>
                        </b-list-group>
                      </div>

                      <b-list-group class="mc-history-fleet__list-total my-2">
                        <b-list-group-item>
                          <div>
                            <p>{{ 'Total' }}</p>
                            <dl class="clearfix">
                              <dt>{{ $t('global.object.tripTime') }}</dt>
                              <dd>
                                {{ summaryTripDriver.summaryTripDriver.totalHourStart }}
                              </dd>
                              <dt>{{ `${$t('global.object.mileage')} (Km)` }}</dt>
                              <dd>
                                {{ summaryTripDriver.summaryTripDriver.totalTrip }}
                              </dd>
                              <dt>{{ $t('global.field.stopDuration') }}</dt>
                              <dd>
                                {{ summaryTripDriver.summaryTripDriver.totalHourStop }}
                              </dd>
                            </dl>
                          </div>
                        </b-list-group-item>
                      </b-list-group>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </section>
            <section v-else class="mc-history-fleet__new">
              <!-- header -->
              <div slot="modal-header">
                <div class="card-title">
                  <h4>{{ $t('global.object.tripHistory') }}<br />{{ $t('global.newest') }}</h4>
                  <McButton
                    class="mc-history-fleet__back"
                    variant="secondary"
                    icon="fas fa-long-arrow-alt-left"
                    :text="$t('global.back')"
                    @click="allHistory = !allHistory"
                  />
                </div>
              </div>

              <!-- Body -->
              <div class="modal-body">
                <div class="mc-history-fleet__new-number">
                  <div class="d-flex justify-content-between">
                    <div>
                      <p>{{ $t('global.fleet') }}</p>
                      <strong>{{ lastSummaryTripDriver.summaryTrips.vehicle.licensePlate }}</strong>
                    </div>
                    <div>
                      <p>{{ $t('global.driver') }}</p>
                      <strong>{{ employee.employee.fullname }}</strong>
                    </div>
                  </div>
                </div>
                <div class="mc-history-modal__list">
                  <div class="mc-history-fleet">
                    <b-list-group class="mc-history-fleet__list">
                      <b-list-group-item>
                        <div class="d-flex justify-content-between">
                          <div>
                            <span> {{ $t('global.object.startTime') }}</span>
                            <p>
                              {{ momentDMY_HI(lastSummaryTripDriver.summaryTrips.startTime) }}
                            </p>
                          </div>
                          <div>
                            <span> {{ $t('global.object.stopTime') }}</span>
                            <p>
                              {{ momentDMY_HI(lastSummaryTripDriver.summaryTrips.stopTime) }}
                            </p>
                          </div>
                          <div>
                            <a
                              class="text-primary"
                              @click="
                                createPolylineMoving(lastSummaryTripDriver.totalHourStop, true)
                              "
                            >
                              <i class="icon-outline_play-circle" />
                            </a>
                          </div>
                        </div>
                        <dl class="clearfix">
                          <dt>{{ $t('global.object.tripTime') }}</dt>
                          <dd>{{ lastSummaryTripDriver.totalHourStart }}</dd>
                          <dt>{{ `${$t('global.object.mileage')} (Km)` }}</dt>
                          <dd>{{ lastSummaryTripDriver.totalTrip }}</dd>
                          <dt>{{ $t('global.field.stopDuration') }}</dt>
                          <dd>{{ lastSummaryTripDriver.totalHourStop }}</dd>
                        </dl>
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </div>
              </div>
            </section>
          </b-modal>
        </div>
      </div>
    </div>
  </Layout>
</template>
